import React, { useState, useEffect } from 'react';
import './Home.css';
import { apiPath, apiKey } from '../../constants';
import { withRouter, useHistory } from 'react-router-dom';

function HomePage(props) {

    let history = useHistory();
    const [isloading, setisLoading] = useState(false);
    const [popupmsg, setPopupmessage] = useState(false);
    const [passreset, setPassreset] = useState(false);
    const [headerinfo, setHeaderInfo] = useState('Login as a Admin User')
    const [popupinfo, setPopupInfo] = useState('')
    const [resetpasswordstatus, setResetPasswordstatus] = useState(false)
    const [loginError, setLoginError] = useState(false)
    const [passwordResetError, setPasswordResetError] = useState(false)




    const clearEnteredUserFields = () => {
        document.getElementById("username").value = '';
        document.getElementById("password").value = '';
    }

    const clearEnteredSchoolFields = () => {
        document.getElementById("schoolcode").value = '';
        document.getElementById("usname").value = '';

    }

    const loginfunction = () => {

        var username = document.getElementById("username").value;
        var password = document.getElementById("password").value;
        setLoginError(false)

        setisLoading(true);

        fetch(apiPath + 'users/schools/user', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            },
            body: JSON.stringify({
                "username": username,
                "password": password
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log("qwerty", data)

                if (data && data.status === 'success') {
                    setUserLoginData(data.data[0])
                    if (data.data[0].role_code === 'SADMN') {
                        history.push("/Schools")
                    }
                    if (data.data[0].role_code === 'ADMN') {
                        history.push("/Teachers")
                    }
                    if (data.data[0].role_code === 'STDADMN') {
                        history.push("/Students")
                    }
                } else {
                    if (data && data.status === 'failed') {
                        setLoginError(true)
                    }
                    else {
                        togglePopUp()
                    }

                }
                setisLoading(false);
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
    }

    const togglePopUp = () => {
        setPopupmessage(!popupmsg)
    }

    const setUserLoginData = (userDetails) => {
        localStorage.setItem('kokos_userdata', JSON.stringify(userDetails));
        props.onUserDataChange(userDetails);
    }

    const resetpassword = () => {
        setPassreset(!passreset);
    }

    const resetpasswordApiCall = () => {

        setPasswordResetError(false)
        let emptyStringStatus = false
        var schoolcode = document.getElementById("schoolcode").value;
        var username = document.getElementById("usname").value;


        if (schoolcode === '' || username === '') {
            setPasswordResetError(true)
            emptyStringStatus = true

        }
        if (emptyStringStatus == false) {
            setisLoading(true);
            fetch(apiPath + 'users/schools/' + schoolcode + '/user/' + username + '/resetpassword', {
                method: 'POST',
                headers: {
                    'x-api-key': apiKey
                },
                body: JSON.stringify({

                })
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status == 'success') {
                        setPopupInfo(data.message + ' \n The new password is : ' + data.new_password)
                        setResetPasswordstatus(true)
                    }
                    else {
                        setPasswordResetError(true)

                        setPopupInfo('Failed to reset password')
                    }

                    setisLoading(false);
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
        }
    }

    return (
        <div className="Homemain">
            <div className="homepage_des">{headerinfo}</div>
            {
                isloading ?
                    <div className="loadingMain">
                        <img className="loadingImage" src={require('../../images/loading2.gif')} alt="loading" />
                    </div>
                    :
                    <div className="Home-Login-main">
                        <div className="homepage_inner">
                            <img className="homepageImage" src={require('../../images/admin.jpg')} />
                            {
                                passreset === false ?
                                    <form className="home_form_main">
                                        <input className="Home-input" type="text" id="username" placeholder="Username" />
                                        <input className="Home-input" type="password" id="password" placeholder="password" required />
                                        {loginError && <div style={{ color: "red" }}>*username or password is incorrect*</div>}
                                        <div className="HomepageLogin" onClick={() => loginfunction()}>LOGIN</div>
                                        <div className="Homepage_forgot" onClick={() => { resetpassword(); setHeaderInfo("Reset Your Password"); setLoginError(false); clearEnteredUserFields() }}>Forgot your password?</div>
                                    </form>
                                    :
                                    <form autoComplete="off" className="home_form_main">
                                        <input className="Home-input" type="text" id="schoolcode" placeholder="School Code" />
                                        <input className="Home-input" type="text" id="usname" placeholder="User Name"
                                            required />
                                        {passwordResetError && <div style={{ color: "red" }}>*username or school code is incorrect*</div>}
                                        <div className="HomepageLogin" onClick={() => { resetpasswordApiCall(); togglePopUp() }}>Reset Password</div>
                                        <div className="Homepage_forgot" onClick={() => { resetpassword(); setHeaderInfo("Login as a Admin User"); clearEnteredSchoolFields(); setPasswordResetError(false) }}>Login page</div>
                                    </form>
                            }
                        </div>
                    </div>
            }
            {popupinfo.length > 0 && <div className={`popUpModalBackground popUpmodalShowing-${popupmsg}`}>
                <div>
                    <div className="popUpModal-success">
                        {resetpasswordstatus && <img className="popUpModal-successimg" src={require('../../images/success.png')} />}
                        {!resetpasswordstatus && <img className="popUpModal-successimg" src={require('../../images/warning.png')} />}
                    </div>
                    <div className="popUpModal-Content">
                        {popupinfo}
                        <div className="popUpModal-submitOutter">
                            <div className="popUpModal-submitInner" onClick={() => { togglePopUp(); setPopupInfo(''); setResetPasswordstatus(false) }}>close</div>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    );
}

export default (withRouter(HomePage));